(function () {
    'use strict';

    class SubscriptionCheckoutController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, Recurly, AccountsManager, UsersManager, $timeout, Enums, $translate, $q, MemberReferralsManager, CouponsService, AnalyticsService, AppcuesService, FacebookPixelTrackingService, AbTestService, OnboardingService, GoogleTagManagerService) {
            super($scope, $injector);
            this.__objectType = 'SubscriptionCheckoutController';

            this.Recurly = Recurly;
            this.MemberReferralsManager = MemberReferralsManager;
            this.CouponsService = CouponsService;
            this.UsersManager = UsersManager;
            this.AccountsManager = AccountsManager;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.AnalyticsService = AnalyticsService;
            this.AppcuesService = AppcuesService;
            this.FacebookPixelTrackingService = FacebookPixelTrackingService;
            this.AbTestService = AbTestService;
            this.OnboardingService = OnboardingService;
            this.Enums = Enums;
            this.$translate = $translate;
            this.$q = $q;
            this.GoogleTagManagerService = GoogleTagManagerService;
        }

        $onInit() {
            this.isReady = false;
            this.currPlanCode = this.Enums.pricingPlanTypes.monthly;
            this.isAnnualPlan = false;
            this.monthlyPlanPrice = 0;
            this.isShowFields = false;
            this.ApplyText = this.$translate.instant('SETTINGS.SUBSCRIPTION._APPLY_PROMO_CODE_');
            this.AppliedText = this.$translate.instant('SETTINGS.SUBSCRIPTION._APPLIED_PROMO_CODE_');

            this.user = this.UsersManager.getCurrUser();

            this.initCouponData();
            this.initPricingData();
            this.resetSubmitButton();
        }

        initCouponData() {
            this.isShowCouponField = false;
            this.isCouponValid = true;
            this.isCouponApplied = false;
            this.btnApplyText = this.ApplyText;
            this.clearCouponErrors();
        }

        onPricingPlanChange() {
            this.currPlanCode = this.isAnnualPlan ? this.Enums.pricingPlanTypes.annual : this.Enums.pricingPlanTypes.monthly;
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.pricing_plan_toggle, {source: this.currPlanCode});

            this.clearCouponErrors();
            this.getServerCouponCode()
                .then( serverCouponCode => {
                    // init with current plan code and coupon
                    this.$timeout (()=> {
                        this.checkoutPrice(this.currPlanCode, serverCouponCode);
                    }, 0);
                })
                .catch((err) => {
                    this.setCouponValidity(false, err.message);
                    this.checkoutPrice(this.currPlanCode);
                });
        }

        getApplyCouponText() {
            if (this.isCouponApplied) {
                return this.AppliedText;
            }
            return this.ApplyText;
        }

        resetSubmitButton() {
            this.isSubmitTriggered = false;
        }

        onSubmit() {
            this.isSubmitTriggered = true;
        }

        getServerCouponCode() {
            const userCouponCode = this.CouponsService.getCoupon() || this.user.referral_container.referred_by_code;
            if (userCouponCode) {
                this.userCouponCode = userCouponCode;
                return this.applyCoupon(userCouponCode);
            } else {
                const defer = this.$q.defer();
                defer.resolve();
                return defer.promise;
            }

        }

        initPricingData() {
            this.Recurly.then(this._initPricingDataLogic.bind(this));
        }

        _initPricingDataLogic(recurlySdk) {
            this.pricing = recurlySdk.Pricing();
            this.pricing.on('set.plan', this.onSetPlan.bind(this));

            // get the monthly price
            this.pricing
                .plan('monthly', { quantity: 1 })
                .currency('USD')
                .catch()
                .done();

            this.getServerCouponCode().then( serverCouponCode => {
                // init with current plan code and coupon
                this.$timeout (()=> {
                    this.checkoutPrice(this.currPlanCode, serverCouponCode);
                }, 0);
            })
            .catch((err) => {
                this.setCouponValidity(false, err.message);
                this.checkoutPrice(this.currPlanCode);
            });
        }

        showFields() {
            this.isShowFields = true;
        }

        purchaseSubscription(token) {
            if(this.loading) {
                return;
            }

            this.loading = true;

            var analyticsEvent = 'submit payment plan';
            var analyticsData = {
                plan_type: this.currPlanCode,
                promo: this.serverCouponCode
            };

            this.AnalyticsService.trackClick(this, analyticsEvent, analyticsData);

            this.AccountsManager.purchaseSubscription(this.currPlanCode, this.serverCouponCode, token.id)
                .then(() => {
                    this.AnalyticsService.trackSuccess(this, analyticsEvent, analyticsData);

                    var mta_mixpanel_params = {};
                    mta_mixpanel_params.user_id = this.user._id;
                    mta_mixpanel_params.company_id = this.user.company._id;

                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.mta_subscribe, mta_mixpanel_params);
                    this.AnalyticsService.trackGA(this, "subscribe", undefined, "product attribution", this.user.attribution.user_source_secondary, true);
                    this.AppcuesService.trackEvent("subscribe", this.user);
                    // fix number we got from Dan (marketing) which stands for the user LTV
                    this.FacebookPixelTrackingService.track('Purchase',{'currency': 'USD', 'value': 1300.00, 'predicted_member_segment_measurement': this.user.account.predicted_member_segment_v5});

                    this.GoogleTagManagerService.trackEvent('purchaseSubscription', {predicted_member_segment_measurement: this.user.account.predicted_member_segment_v5});

                    this.AbTestService.onCompanySubscribed();
                    this.OnboardingService.onCompanySubscribed();
                    this.CouponsService.reset();
                    if (this.onPurchaseSuccess) {
                        this.onPurchaseSuccess({plan: this.user.getSubscription().pricing_plan});
                    }
                })
                .catch(res => {
                    var analyticsData = {};
                    var errorMessage =  'ERRORS.SERVER_API._UNKNOWN_';
                    if (res && res.error && res.error.message) {
                        errorMessage = res.error.message;
                    } else if (res && res.data && res.data.error_message) {
                        errorMessage = res.data.error_message;
                    }

                    this.cardError = errorMessage;

                    analyticsData.error = res ? res : "no error data";
                    this.AnalyticsService.trackError(this, analyticsEvent, analyticsData);
                }).finally(() => {
                    this.loading = false;
                });
        }

        showCouponField() {
            this.isShowCouponField = true;
        }

        clearCouponErrors() {
            this.setCouponValidity(true, '');
        }

        setCouponValidity(isValid, errorMessage) {
            this.isCouponValid = isValid;
            this.couponErrorMessage = errorMessage;
        }

        submitCoupon(event) {
            event.stopPropagation();

            this.isCouponApplied = false;
            if(!this.userCouponCode || this.userCouponCode === "") {
                this.checkoutPrice(this.currPlanCode);
                this.CouponsService.reset();
            } else {
                this.applyCoupon(this.userCouponCode)
                    .then(serverCouponCode => {
                        this.checkoutPrice(this.currPlanCode, serverCouponCode);
                    })
                    .catch(err => {
                        this.setCouponValidity(false, err.message);
                    });
            }
        }

        hasReferrralDiscount() {
            return !!this.referralCode;
        }

        saveReferral(referralCode) {
            let deferred = this.$q.defer();
            this.MemberReferralsManager.saveReferral({
                referral_code: referralCode.code,
                referred_id: this.user._id,
                source: 'promo_code'
            })
                .then(resp => {
                    let referral = resp.data;
                    if(referral.status !== 'member') {
                        deferred.resolve(referral);
                    } else {
                        deferred.reject({message: 'Cannot use a redeemed referral'});
                    }
                })
                .catch(err => {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        applyCoupon(userCouponCode) {
            let deferred = this.$q.defer();
            this.MemberReferralsManager.getReferralCode(userCouponCode)
                .then(resp => {
                    if(resp.data && resp.data.coupon) {
                        const serverCouponCode = resp.data.coupon;
                        this.saveReferral(resp.data)
                            .then(() => {
                                this.referralCode = resp.data;
                                deferred.resolve(serverCouponCode);
                            })
                            .catch(err => {
                                deferred.reject(err);
                            });
                    } else {
                        this.referralCode = null;
                        deferred.resolve(userCouponCode);
                    }
                });
            return deferred.promise;
        }

        discountTooltipText() {
            var annualDiscountText = '$80 savings for Annual, plus ';

            return (this.isAnnualPlan ? annualDiscountText : '') + '$' + this.discount + ' referral discount from ' + this.referralCode.code_owner.full_name;
        }

        checkoutPrice(planCode, coupon) {
            this.pricing
                .plan(planCode, { quantity: 1 })
                .coupon(coupon)
                .currency('USD')
                .catch(err => {
                    // assume that the error was due to wrong coupon, so don't use it.
                    this.setCouponValidity(false, err.message);
                })
                .done(priceObject => {
                    this.isCouponApplied = coupon && this.isCouponValid;
                    if (this.isCouponApplied) {
                        this.serverCouponCode = coupon;
                        this.CouponsService.applyCoupon(this.userCouponCode);
                    }
                    this.updatePrice(priceObject);
                });
        }

        updatePrice(pricingObject) {
            this.discount = Number(pricingObject.now.discount);
            this.totalNow = Number(pricingObject.now.total);
            this.pricePerMonth = Math.ceil(this.totalNow / this.planPeriod);
            this.totalSave = (this.monthlyPlanPrice * this.planPeriod - this.totalNow);

            this.isReady = true;
            this.$scope.$applyAsync();
        }

        onSetPlan(planObject) {
            if (planObject.code === this.Enums.pricingPlanTypes.monthly) {
                this.monthlyPlanPrice = Number(planObject.price.USD.unit_amount);
            }
            this.planPeriod = Number(planObject.period.length);
        }
    }

    Components.SubscriptionCheckout = {
        controller: SubscriptionCheckoutController,
        bindings: {
            onPurchaseSuccess: '&?',
            activePricingPlan: '=?'
        },
        name: 'hbSubscriptionCheckout',
        templateUrl: 'angular/app/modules/core/features/settings/company/subscription/subscription_checkout.html',

    };
}());
